import { Box, CircularProgress, Paper, Typography } from '@mui/material';
import {
  NotificationTypeEnum,
  useNotification,
} from '@prismamedia/one-components';
import { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { paths } from '../../routing';
import { loginWithAzureIdToken } from '../../utils/auth';
import { getAzureIdTokenFromRedirect } from '../../utils/azureAuth';

const LOGIN_BACKGROUND =
  "url('https://one.img.pmdstatic.net/fit/http.3A.2F.2Frec2-bone-image.2Es3-website-eu-west-1.2Eamazonaws.2Ecom.2Fcap.2F2020.2F12.2F11.2F0db5a9b3-2a0b-4dbe-83e9-562cf9b5a02a.2Ejpeg/800x450/quality/100/crop-from/top/transformation.jpg')";

export const AzureCallback: FC = () => {
  const history = useHistory();
  const { pushNotification } = useNotification();

  useEffect(() => {
    const completeAzureLogin = async () => {
      try {
        const idToken = await getAzureIdTokenFromRedirect();
        if (!idToken) {
          throw new Error('Erreur de connexion');
        }
        const jwt = await loginWithAzureIdToken(idToken);
        if (!jwt) {
          throw new Error('Erreur de connexion');
        }
        history.replace(paths.CAMPAIGN_LIST);
      } catch (error) {
        pushNotification({
          message:
            error instanceof Error ? error.message : 'Erreur de connexion',
          type: NotificationTypeEnum.error,
        });
        history.replace(paths.LOGIN);
      }
    };

    void completeAzureLogin();
  }, [history, pushNotification]);

  return (
    <Box
      sx={{
        alignItems: 'center',
        background: LOGIN_BACKGROUND,
        backgroundSize: 'cover',
        display: 'flex',
        height: '100vh',
        justifyContent: 'center',
        width: '100vw',
      }}
    >
      <Paper
        sx={{
          alignItems: 'center',
          backgroundColor: 'common.white',
          display: 'flex',
          flexDirection: 'column',
          padding: '40px',
        }}
      >
        <CircularProgress />
        <Typography sx={{ marginTop: 2 }}>
          Connexion Microsoft en cours…
        </Typography>
      </Paper>
    </Box>
  );
};
